export function selectTicketIdFromProps(state, props) {
  return props.ticketId || null
}
